@link fn getScissorA(value: vec4<f32>, uv: vec4<f32>, st: vec4<f32>) -> vec4<f32>;
@link fn getScissorB(value: vec4<f32>, uv: vec4<f32>, st: vec4<f32>) -> vec4<f32>;

@export fn getScissorCombine(value: vec4<f32>, uv: vec4<f32>, st: vec4<f32>) -> vec4<f32> {
  return min(getScissorA(value, uv, st), getScissorB(value, uv, st));
};
